import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'

import { useDebounce } from '../../../hooks/useDebounce'
import styles from './Buscador.module.css'

const BUSCADOR_DELAY_MS = 500

export const Buscador = ({ busqueda, setBusqueda, onChange, placeholder = 'Buscar...' }) => {
  const busquedaDebounceada = useDebounce(busqueda ?? '', BUSCADOR_DELAY_MS)
  const busquedaNotificada = useRef(busquedaDebounceada)

  useEffect(() => {
    if (busquedaNotificada.current === busquedaDebounceada) {
      return
    }

    busquedaNotificada.current = busquedaDebounceada
    onChange?.(busquedaDebounceada.trim().toLowerCase())
  }, [busquedaDebounceada])

  const handleInputChange = (e) => {
    setBusqueda(e.target.value)
  }

  return (
    <input
      type="text"
      className={styles.buscador}
      value={busqueda}
      onChange={handleInputChange}
      placeholder={placeholder}
    />
  )
}

Buscador.propTypes = {
  busqueda: PropTypes.string.isRequired,
  setBusqueda: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.string
}
